import { Controller } from "@hotwired/stimulus"
import { gsap } from "gsap"

export default class extends Controller {
	static targets = ["detail", "nav"]

	static values = {
		open: {
			type: Boolean,
			default: false
		}
	}

	toggle() {
		this.openValue = !this.openValue
	}

	openValueChanged(newValue) {
		if (newValue) {
			this.detailTarget.open = true

			const scrollHeight = this.navTarget.scrollHeight
			gsap.to(this.navTarget, {
				height: scrollHeight,
				duration: 0.75,
				ease: "circ.inOut"
			})
		} else {
			gsap.to(this.navTarget, {
				height: 0,
				duration: 0.75,
				ease: "circ.inOut",
				onComplete: () => {
					this.detailTarget.open = false
				}
			})
		}
	}
}
